import * as z from 'zod';

export const customMemoPayloadSchema = z.object({
  // catch(undefined) mostly to fallback from null to optional
  type: z.string().optional().catch(undefined),
  hook_interface: z.string().optional().catch(undefined),
  configuration: z.record(z.unknown()).default({}),
  index_formula: z.string().optional().catch(undefined),
});
